@if (isLocal) {
  <button
    appButton
    variant="ghost"
    size="icon"
    [matMenuTriggerFor]="themeMenu"
    aria-label="Seleccionar tema"
  >
    <mat-icon>palette</mat-icon>
  </button>

  <mat-menu #themeMenu="matMenu">
    <button mat-menu-item (click)="selectTheme('none')">
      <span>Ninguno (Default)</span>
    </button>
    <mat-divider></mat-divider>
    @for (theme of themeService.sortedThemes(); track theme) {
      <button mat-menu-item (click)="selectTheme(theme)">
        <mat-icon [class.active]="themeService.currentTheme() === theme">
          {{ themeService.currentTheme() === theme ? "check" : "" }}
        </mat-icon>
        <span>{{ theme }}</span>
      </button>
    }
  </mat-menu>
}
